import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/flexible'
import Element from 'element-ui'
import './assets/css/element-variables.scss'
import plugins from './plugins'
import {
  getToken
} from '@/utils/auth'

import VueLazyload from 'vue-lazyload'

// 全局组件
import globalComponent from '@/utils/components'
Vue.use(globalComponent)

Vue.use(plugins)
Vue.use(Element)

Vue.use(VueLazyload, {
	preLoad: 1.3,
	error: require('@/assets/images/layout/default-bg.jpg'),
	loading: require('@/assets/images/layout/default-bg.jpg'),
	attempt: 2
})

import Aes from "@/utils/aes.js"
Vue.prototype.$Aes = Aes

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (getToken()) {
    if (to.path == '/login') {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else {
    if (to.path.indexOf('/user/manage') != -1 || to.path.indexOf('/organization/manage') != -1 || to.path.indexOf('/site/manage') != -1) {
      next('/login')
    } else {
      next()
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
